<script>
import { defineComponent } from "vue";
import { Line } from "vue3-chart-v2";

export default defineComponent({
  name: "UserReportChart",
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, {
      legend: {
        display: false,
      },
    });
  },
  watch: {
    chartData(value) {
      this.renderChart(value, {
        responsive: true,
        legend: {
          display: false,
        },
      });
    },
  },
});
</script>
